import React, { useRef, useEffect } from 'react'

//Styles 
import styles from './DocumentImage.module.css'

interface Props {
  src: string
  alt: string,
  innerStyle?: string,
  width?: string,
  height?: string
}

const DocumentImage = ({ src, alt, innerStyle, width, height }:Props) => {

  const imageRef = useRef<HTMLImageElement>(null)
  useEffect(()=> {
    if (innerStyle) imageRef.current?.setAttribute('style', innerStyle)
    if (width) imageRef.current?.setAttribute('width', width+'px')
    if (height) imageRef.current?.setAttribute('height', height+'px')
  }, []) /* eslint-disable-line */  

  return (
    <img className={styles.image} src={src} alt={alt} ref={imageRef}/>
  )
}

export default DocumentImage